import { graphql, Link, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import FacebookIcon from '../../../../images/icon-facebook-alt2.inline.svg';
import InstagramIcon from '../../../../images/icon-instagram-alt.inline.svg';
import PinterestIcon from '../../../../images/icon-pinterest.inline.svg';
import TwitterIcon from '../../../../images/icon-twitter.inline.svg';
import { convertStringToLowercase } from '../../../../utils/convertValues';
import { getURLPathname } from '../../../../utils/parseURL';
import { SITE_PRODUCTION_URL } from '../../../../constants/global';

export const FooterListItem = (props) => {
  const {
    pageData: {
      contentLink: { url = '#' },
      listHeading = null,
      name = null,
      listSubHeading = null,
      child: pageUrl
    }
  } = props;
  const filteredPages = pageUrl?.filter((page) => page.showInMenu);

  return (
    <li className="footer-navigation__item">
      <div className="footer-navigation__item-header">
        {url && (listHeading || name) && (
          <div className="footer-navigation__item-header-heading">
            <Link to={getURLPathname(url)}>{listHeading || name}</Link>
          </div>
        )}

        {listSubHeading && (
          <p aria-label={listSubHeading}>
            <span aria-label={listSubHeading}>{listSubHeading}</span>
          </p>
        )}
      </div>

      {filteredPages && Array.isArray(filteredPages) && filteredPages?.length > 0 ? (
        <ul className="footer__sub-navigation">
          {filteredPages.map((item, index) => {
            let url =
              typeof item?.contentLink?.url === 'string' && item?.contentLink?.url?.length > 0
                ? item.contentLink.url.replace(SITE_PRODUCTION_URL, '')
                : typeof item?.node?.custom_url?.url === 'string' && item?.node?.custom_url?.url?.length > 0
                ? item.node.custom_url.url
                : '#';

            return (
              <li
                key={index}
                className="footer__sub-navigation-item"
                aria-label={
                  typeof item?.listHeading === 'string' && item?.listHeading?.length > 0
                    ? convertStringToLowercase(item.listHeading)
                    : typeof item?.name === 'string' && item?.name?.length > 0
                    ? convertStringToLowercase(item.name)
                    : typeof item?.node?.name === 'string' && item?.node?.name?.length > 0
                    ? convertStringToLowercase(item.node.name)
                    : ''
                }
              >
                <Link
                  to={url}
                  aria-label={
                    typeof item?.listHeading === 'string' && item?.listHeading?.length > 0
                      ? convertStringToLowercase(item.listHeading)
                      : typeof item?.name === 'string' && item?.name?.length > 0
                      ? convertStringToLowercase(item.name)
                      : typeof item?.node?.name === 'string' && item?.node?.name?.length > 0
                      ? convertStringToLowercase(item.node.name)
                      : ''
                  }
                >
                  {typeof item?.listHeading === 'string' && item?.listHeading?.length > 0
                    ? item.listHeading
                    : typeof item?.name === 'string' && item?.name?.length > 0
                    ? item.name
                    : typeof item?.node?.name === 'string' && item?.node?.name?.length > 0
                    ? item.node.name
                    : ''}
                </Link>
              </li>
            );
          })}
        </ul>
      ) : null}
    </li>
  );
};

FooterListItem.propTypes = {
  pageData: PropTypes.shape({
    listSubHeading: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string
  }),
  pageUrl: PropTypes.array
};

/**
 * @description Render memoized social links of footer item
 * @returns {JSX.Element} Memoized footer social link
 */
export const FooterSocialLinks = memo(function MemoizedFooterSocialLinks() {
  // GraphQL queries
  const FooterSocialLinksQuery = graphql`
    {
      allOptimizelyHomePageContentChildren(filter: { contentLink: { id: { eq: 14101 } } }) {
        edges {
          node {
            instagramUrl
            facebookUrl
            twitterUrl
            pinterestUrl
          }
        }
      }
    }
  `;

  const { allOptimizelyHomePageContentChildren } = useStaticQuery(FooterSocialLinksQuery);

  const {
    edges: [
      {
        node: { instagramUrl, facebookUrl, twitterUrl, pinterestUrl }
      }
    ]
  } = allOptimizelyHomePageContentChildren;

  return (
    <ul className="footer__follow-list">
      {typeof instagramUrl === 'string' && instagramUrl?.length > 0 ? (
        <li>
          <a href={instagramUrl} target="instagram" rel="noreferrer noopener">
            <InstagramIcon />
          </a>
        </li>
      ) : null}

      {typeof facebookUrl === 'string' && facebookUrl?.length > 0 ? (
        <li>
          <a href={facebookUrl} target="facebook" rel="noreferrer noopener">
            <FacebookIcon />
          </a>
        </li>
      ) : null}

      {typeof twitterUrl === 'string' && twitterUrl?.length > 0 ? (
        <li>
          <a href={twitterUrl} target="twitter" rel="noreferrer noopener">
            <TwitterIcon />
          </a>
        </li>
      ) : null}

      {typeof pinterestUrl === 'string' && pinterestUrl?.length > 0 ? (
        <li>
          <a href={pinterestUrl} target="pinterest" rel="noreferrer noopener">
            <PinterestIcon />
          </a>
        </li>
      ) : null}
    </ul>
  );
});
